<template>
  <ul class="x-tabs" v-if="tabs.length">
    <li
      class="x-tab-item"
      :class="{ 'x-tab-item-current': curTab == item.id }"
      @click="onChangeTab(item)"
      v-for="(item, index) in tabs"
      :key="index"
    >
      <span>{{ item.label }}</span>
      <div class="x-tab-line"></div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "x-tabs",
  props: {
    value: {
      default: "",
    },
    // 格式 [{id: 0, label: 'lalala'}]
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.curTab = val;
      },
    },
    curTab(val) {
      this.$emit("update:value", val);
      this.$emit("on-change", val);
    },
  },
  data() {
    return {
      curTab: "",
    };
  },
  created() {},
  methods: {
    // on event
    onChangeTab(item) {
      this.curTab = item.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.x-tabs {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  overflow: hidden;
  .x-tab-item {
    float: left;
    height: 35px;
    font-size: 16px;
    color: #666;
    text-align: center;
    cursor: pointer;
    position: relative;
    margin-right: 48px;
    span {
      display: inline-block;
    }
  }
  .x-tab-item-current {
    color: $primary-color;
    font-weight: 500;
    .x-tab-line {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 4px;
      border-radius: 10px 10px 0 0;
      background-color: $primary-color;
      display: block;
    }
  }
}
</style>
